/** Pure screen<->fraction helpers for the title-block region editor. Kept out
 *  of the component so the coordinate maths is unit-tested without a DOM. */
import type { FractionalRect } from '../utils/titleBlockTemplate';

const clamp01 = (n: number) => Math.min(1, Math.max(0, n));

/** Two drag points (in render-pixel space) -> a normalised FractionalRect. */
export function rectFromDrag(
  start: { x: number; y: number }, end: { x: number; y: number },
  renderW: number, renderH: number,
): FractionalRect {
  const x0 = clamp01(Math.min(start.x, end.x) / renderW);
  const y0 = clamp01(Math.min(start.y, end.y) / renderH);
  const x1 = clamp01(Math.max(start.x, end.x) / renderW);
  const y1 = clamp01(Math.max(start.y, end.y) / renderH);
  return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
}

export function fractionalToPx(rect: FractionalRect, renderW: number, renderH: number) {
  return {
    left: rect.x * renderW,
    top: rect.y * renderH,
    width: rect.w * renderW,
    height: rect.h * renderH,
  };
}
